<template>
    <div>
        <Heading
            ecommerce
            title="Your Preferred Options for Crosspromotion"
            description="Mention the cross-promotions mediums you can offer to your partners."
        />
        <div>
            <p class="error-text mt-2 pl-2" v-if="errors['no-crossprom-option-selected']">Choose at least one crossprom option</p>
            <ul class="list px-0" :class="{'edit-view': editView}">
                <li v-for="option in info" :key="option.key">
                    <div>
                        <label class="list-label checkbox-holder d-flex m-0">
                            <input class="d-none" type="checkbox" v-model="crosspromOptions[option.key].active">
                            <span class="d-flex justify-content-center align-items-center">
                                <Icon width="14" icon="checkmark" v-if="crosspromOptions[option.key].active"/>
                            </span>
                            <p class="p2b m-0">{{option.title}}</p>
                        </label>
                    </div>
                    <div class="list-subcontent" v-if="crosspromOptions[option.key].active">
                        <ul v-if="option.key === 'social-media-post'" class="list-subcontent p-0">
                            <li v-for="media in crosspromOptions[option.key].info" :key="media.platform" class="d-flex">
                                <Icon :icon="media.platform" class="mr-3"/>
                                <p class="p2n c6 m-0 py-1 text-capitalize mr-2">{{media.platform}} : </p>
                                <p class="p2b c6 m-0 py-1">{{media.followers | numberWithCommas}} followers</p>
                            </li>
                        </ul>

                        <label class="w-100" v-else>
                            <div class="input-holder d-flex" :class="{error: errors[option.errorKey] && !crosspromOptions[option.key].info}">
                                <Icon v-if="option.icon" :icon="option.icon" />
                                <input type="number" v-if="option.infoType === 'number'" v-model.number = "crosspromOptions[option.key].info" :placeholder="option.infoPlaceholder" class="w-100 c6 p2n">  
                                <input type="url" v-else-if="option.infoType === 'url'" v-model = "crosspromOptions[option.key].info" :placeholder="option.infoPlaceholder" class="w-100 c6 p2n">  
                                <textarea v-else v-model.trim= "crosspromOptions[option.key].info" :placeholder="option.infoPlaceholder" class="w-100 c6 p2n"></textarea>
                            </div>
                            <p class="error-text mt-2 mb-0" v-if="(errors[option.errorKey] && !crosspromOptions[option.key].info) || errors[option.errorKey]">{{option.errorMessage}}</p>
                        </label>
                    </div>
                </li>
            </ul>
        </div>
        <slot />
    </div>
</template>
<script>
import Heading from '../Theme/Heading'
import Icon from '../Theme/Icon'
import {numbers} from '../../core/filters'
import {onMounted, ref, watch} from '@vue/composition-api'
import {useErrors} from '../../core/hooks'
import {validationUtils, shopUtils} from '../../core/utils'

export default {
    name: 'CrosspromOptions',
    components: {
        Heading,
        Icon
    },
    props: {
        data: Object,
        editView: Boolean
    },
    filters: {
        numberWithCommas: numbers.numberWithCommas
    },
    setup(props, {emit}){

        const info = ref([...shopUtils.crosspromOptions])

        const crosspromOptions =  ref(props.data.crossprom_options || {
            'email-newsletter': {
                active: false, 
                info: null
            }, 
            'website-banner': {
                active: false, 
                info: null
            }, 
            'social-media-post': {
                active: false, 
                info: [
                    {platform: 'facebook', url: props.data.facebook_url, followers: props.data.facebook_followers},
                    {platform: 'instagram', url: props.data.instagram_url, followers: props.data.instagram_followers}
                ]
            }, 
            'blog-post': {
                active: false, 
                info: null
            }, 
            'other': {
                active: false, 
                info: null
            }
        })

        const errorHandler = useErrors();

        const errors = useErrors().messages;

        const setData = () => {
            emit('setData', {
                ...props.data,
                crossprom_options: crosspromOptions.value
            })
        }


        watch(crosspromOptions, crosspromOptions => {
            emit('setData', {
                ...props.data,
                crossprom_options: crosspromOptions
            })
        })

        const validateFields = () => {
            if(!props.editView) {
                errorHandler.resetErrors()
            }

            if(Object.values(crosspromOptions.value).every(item => !item.active)) {
                errorHandler.setError('no-crossprom-option-selected', true)
                return
            }


            for(let key in crosspromOptions.value) {
                if(crosspromOptions.value[key].active) {
                    
                    let elIndex = info.value.findIndex(x => x.key === key)
                    
                    const emptyValue = !crosspromOptions.value[key].info
                    const notValidNumber = info.value[elIndex].infoType === 'number' && !validationUtils.isNumber(crosspromOptions.value[key].info)
                    const notValidUrl = info.value[elIndex].infoType === 'url' && !validationUtils.isValidUrl(crosspromOptions.value[key].info)
                    const notValidText = info.value[elIndex].infoType === 'text' && !validationUtils.isValidText(crosspromOptions.value[key].info)
                    if(emptyValue || notValidNumber || notValidUrl || notValidText) {
                        info.value[elIndex].errorMessage = info.value[elIndex].errorMessages[emptyValue ? 0 : 1]
                        return errorHandler.setError(info.value[elIndex].errorKey, true)
                    }

                }
            }

            setData()

        }

        return {
            crosspromOptions,
            errors,
            info,
            validateFields,
            setData
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
.list {
    height: 365px;
    &.edit-view {
        height: 500px;
    }
    overflow-y: auto;
    margin-top: 32px;
    &>li {
        background: #FFFFFF;
        box-shadow: 0px 8px 24px -6px rgba(113, 128, 150, 0.16), 0px 0px 1px rgba(113, 128, 150, 0.32);
        border-radius: 4px;
        margin: 0 5px 12px;

        .list-subcontent {
            padding: 24px;
            border-top: 1px solid #E2E8F0;

            li {
                padding: 20px;
            }
        }

        .list-label {
            padding: 16px 20px;
            cursor: pointer;
        }

        .platform-name {
            text-transform: capitalize;
        }
    }

    .checkbox-holder {
        span {
            width: 24px;
            height: 24px;
            border: 1px solid $c1;
            margin-right: 20px;
            border-radius: 50%;
        }

        input:checked + span {
            background: $c1;
        }
    }

    .input-holder {
            padding: 18px;
            border: 1px solid #CBD5E0;
            width: 100%;
            border-radius: 4px;
            &:focus {
                border: 1px solid #CBD5E0;
            }

            img {
                margin-right: 18px;
            }

            input {
                border: none;
                border-radius: 4px;
            }

            textarea {
                border: none;
                border-radius: 4px;
            }

            &.error {
                border: 1px solid $c5o7;
            }

            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }

            /* Firefox */
            input[type=number] {
                -moz-appearance: textfield;
            }
        }
}
</style>
